<template>
  <div class="flex flex-col justify-center items-center w-full my-2">
    <span class="material-icons text-grey opacity-10 text-9xl">
      broken_image
    </span>
    <p class="text-grey text-2xl opacity-30">No data found</p>
  </div>
</template>
